import { createSlice } from '@reduxjs/toolkit';
import {
  fetchSavedDeliverySettings,
  updatedTargetSamples,
  updatedNumberOfQuestions,
  cardPayment,
  logoutAdmin,
  logoutUser,
} from '~/api';

import { PAYMENT_TYPE } from '~/constants';

const initialState = {
  id: null,
  surveyId: null,
  estimatePrice: 0,
  estimatePriceTax: 0,
  estimatePriceTotal: 0,
  price: 0,
  tax: 0,
  priceTotal: 0,
  type: PAYMENT_TYPE.CREDIT_CARD, // 1:クレカ 2:請求書
  redirectUrl: '',
};

/**
 * 支払い情報管理用Slice。
 */
const surveyPaymentSlice = createSlice({
  name: 'surveyPayment',
  initialState,
  reducers: {
    initialize: () => initialState,
    update: (state, action) => {
      return {
        ...state,
        ...action.payload,
      };
    },
  },
  // 非同期はextraReducersで行う
  extraReducers: {
    [fetchSavedDeliverySettings.fulfilled.type]: (state, action) => {
      if (action.payload.surveyPayments === null) {
        return state;
      }
      // ステータスが完了だとtargetSamplesとnumberOfQuestionsが入っているが必要ないので除去。
      const {
        targetSamples: _,
        numberOfQuestions: __,
        ...surveyPayments
      } = action.payload.surveyPayments;

      return {
        ...state,
        ...surveyPayments,
      };
    },

    /**
     * 配信設定画面で回答希望数の内訳が変更された時にトリガーされるAction後のstate更新。
     */
    [updatedTargetSamples.fulfilled.type]: (state, action) => {
      return {
        ...state,
        estimatePriceTotal: action.payload.estimatePriceTotal,
      };
    },

    /**
     * 配信設定画面で設問数が変更された時にトリガーされるAction後のstate更新。
     */
    [updatedNumberOfQuestions.fulfilled.type]: (state, action) => {
      return {
        ...state,
        estimatePriceTotal: action.payload.estimatePriceTotal,
      };
    },

    [cardPayment.fulfilled.type]: (state, action) => {
      return {
        ...state,
        redirectUrl: action.payload.redirectUrl,
      };
    },

    [logoutAdmin.fulfilled.type]: () => {
      return initialState;
    },

    [logoutUser.fulfilled.type]: () => {
      return initialState;
    },
  },
});

// reducerをexportする
export default surveyPaymentSlice.reducer;
